angular
    .module('app')
    .component('b2bPartnersList', {
        templateUrl: '/templates/pages/b2bPartners/b2bPartnersList/b2bPartnersList.html',
        controller: 'B2bPartnersListController',
        controllerAs: 'vm',
    });